export const FREQUENCIA_MAP = {
  1: "Diário",
  2: "Semanal",
  3: "Quinzenal",
  4: "Mensal",
};

export const FREQUENCIA_OPTIONS = Object.entries(FREQUENCIA_MAP).map(([value, descricao]) => ({
  value: Number(value),
  descricao,
}));
